import React, { useEffect, useState } from "react";
import PageHeading from "../common/PageHeading";
import { Phone, Tick } from "../../utils/SvgComponents";
import { EVENT_BASEURL } from "../../utils/Constants";
import { apiHandler } from "../../utils/apiHandler";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";

const Profile = () => {
	const { id } = useParams();
	const [data, setData] = useState([])
	const [isImageLoaded, setIsImageLoaded] = useState(true);
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	let NewUsername = "";

	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data2 = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data2?._id}/`
	console.log(newImgUrl);

	useEffect(() => {
		const fetchProfile = async () => {
			try {
				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: id,
					category: "Profile"
				});
				console.log(res);
				if (res) {
					setData(res);

				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};

		fetchProfile();
	}, [])

	const fadeInUp = {
		initial: { opacity: 0, y: 30 },
		animate: { opacity: 1, y: 0 },
		transition: { duration: 0.6, ease: 'easeOut' }
	};
	console.log(data.skills)
	return (
		<div style={{ zIndex: '333333', backgroundColor: 'white' }}>
			<div className="hidden sm:block h-screen">
				<div className="grid grid-cols-12 h-full">
					<div className="col-span-5 bg-black h-full py-[0.75rem] px-[70px] text-white flex flex-col items-center common-font">
						<PageHeading title="Bride Profile" color={true} />
						<div className="flex flex-col justify-center items-center flex-auto">
							<motion.div {...fadeInUp}
								className="rounded-full border-2 border-white overflow-hidden w-1/3"
							>
								<div className="">
									{data.basicDetails && <img
										src={newImgUrl + data.basicDetails.profileImg}
										alt=""
										className={`
									transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
											}
									`}
										onLoad={() => setIsImageLoaded(false)}
									/>}
								</div>
							</motion.div>
							<motion.div {...fadeInUp}>
								<div className="uppercase text-center mt-[25px] mb-[40px]">
									<div className="text-3xl font-medium mb-[10px] tracking-[0.61px]">
										{data.basicDetails && data.basicDetails.name}
									</div>
									<div className="text-xl tracking-[0.2px]">
										{data.basicDetails && data.basicDetails.currentDesignation}
									</div>
								</div>
							</motion.div>
							<motion.div {...fadeInUp}>
								<div className="relative ">
									<div className="absolute text-[22px] top-[-16px] left-[15px] bg-black px-[12px] font-semibold z-50 tracking-[0.3px]">
										About Me
									</div>
									<div className="border-2 border-white p-[20px] text-[18px] text-justify rounded-xl tracking-[0.2px]">
										{data.basicDetails && data.basicDetails.about}
									</div>
								</div>
							</motion.div>
						</div>
					</div>
					<div className="col-span-7 p-10">
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-10 h-full">
							<div className="flex flex-col gap-8 justify-center ">
								<motion.div {...fadeInUp} >
									<div className="relative common-font tracking-[0.1px]">
										<div className="absolute text-[22px] text-[#2d2d2d] font-semibold top-[-16px] left-3 px-2 bg-white z-10 tracking-[0.3px]" >
											Education
										</div>
										<div className="border-2 border-[#2d2d2d] rounded-xl p-4 px-3 py-6">
											{data.education && data.education.map((edu, index) => (
												<div className="flex justify-between items-start relative">
													<div className="flex justify-center items-center gap-[0.75rem]">
														<div className="bg-[#2d2d2d] rounded-full p-1">
															<Tick
																width="13"
																height="13"
																fill="white"
															/>
														</div>
														<div>
															<p className="font-semibold text-[18px] text-[#2d2d2d] m-0 tracking-[0.15px]">
																{edu.major}
															</p>
															<span className="text-[#2d2d2d] tracking-[0.1px]">
																{edu.college}
															</span>
														</div>
													</div>
													<div className="underline text-[#2d2d2d]">
														{edu.year}
													</div>
													{data.education.length - 1 !== index && <hr className="absolute left-[-11.5px] bottom-0 top-[59px] w-11 rotate-90 border-[2px] border-[#2d2d2d] rounded-full opacity-100 border-solid m-0" />}

												</div>
											))}
										</div>
									</div>
								</motion.div>
								<motion.div {...fadeInUp} >
									<div className="relative common-font tracking-[0.3px]">
										<div className="absolute text-[22px] top-[-16px] left-3 px-[8px] text-[#2d2d2d] font-semibold bg-white z-10">
											Skills
										</div>
										<div className="border-2 border-[#2d2d2d] rounded-xl px-6 py-6">
											{data.skills && data.skills.map((skill, index) => {
												return (
													<div className="">
														<div className="mb-2 text-[#2d2d2d] text-[18px] font-semibold tracking-[0.15px]">
															{skill.name}
														</div>
														<div class=" w-full bg-gray-200 rounded-full h-1 mb-3">
															<div style={{ width: `${skill.percentage}%` }} class={`bg-[#2d2d2d] h-1 w-[${skill.percentage}%] rounded-full`}></div>
														</div>
													</div>
												)
											})}
										</div>
									</div>
								</motion.div>
							</div>
							<div className="flex flex-col gap-8 justify-center">
								<motion.div {...fadeInUp} >
									<div className="relative common-font ">
										<div className="absolute text-[22px] top-[-16px] left-3 px-2 text-[#2d2d2d] font-semibold bg-white z-10 tracking-[0.3px]">
											Certifications
										</div>
										<div className="border-2 border-[#2d2d2d] rounded-xl px-3 py-6">
											{data.certification && data.certification.map((item, i) => (
												<span
													key={i}
													className="bg-[#2d2d2d] text-[14px] inline-block  text-white py-1 px-3 rounded-full m-[5px]"
												>
													{item}
												</span>
											))}
										</div>
									</div>
								</motion.div>
								<motion.div {...fadeInUp} >
									<div className="relative common-font">
										<div className="absolute text-[21px] text-[#2d2d2d] font-semibold top-[-16px] left-3 px-2 bg-white z-10 tracking-[0.3px]">
											Work Experience
										</div>
										<div className="border-2 border-[#2d2d2d] rounded-xl p-4 px-3 py-6">
											{data.experience && data.experience.map((work, index) => (
												<div className="flex justify-between items-start relative">
													<div className="flex justify-center items-center gap-[0.75rem]">
														<div className="bg-[#2d2d2d] rounded-full p-1">
															<Tick
																width="13"
																height="13"
																fill="white"
															/>
														</div>
														<div>
															<p className="font-semibold text-[18px] text-[#2d2d2d] m-0 tracking-[0.15px]">
																{work.designation}
															</p>
															<span className="text-[#2d2d2d] tracking-[0.1px]">
																{work.company}
															</span>
														</div>
													</div>
													<div className="underline text-[#2d2d2d] ">
														{work.year}
													</div>
													{
														data.experience.length - 1 !== index && (
															<hr className="absolute left-[-11.5px] top-[43px] w-11 rotate-90 border-[2px] border-[#2d2d2d] rounded-full opacity-100 border-solid" />
														)
													}
												</div>
											))}
										</div>
									</div>
								</motion.div>
								<motion.div {...fadeInUp} >
									<div className="relative common-font">
										<div className="absolute text-[22px] top-[-16px] left-3 px-2 bg-white text-[#2d2d2d] font-semibold z-10 tracking-[0.4px]">
											Achievements
										</div>
										<ul className="border-2 border-[#2d2d2d] rounded-xl pt-2 px-3 m-0">
											{data.achievements && data.achievements.map((item, i) => (
												<li className="flex items-center gap-2 ms-1 my-3">
													<div className="bg-[#2d2d2d] p-[5px] rounded-full"></div>
													<div className="font-medium text-[18px] tracking-[0.15px]">
														{item}
													</div>
												</li>
											))}
										</ul>
									</div>
								</motion.div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="block sm:hidden h-svh overflow-scroll ">

				<div className="relative mb-16 border-b border-black ">
					{data.basicDetails && <img
						src={newImgUrl + data.basicDetails.profileCoverBg}
						className={`
									transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
							}
									`}
						onLoad={() => setIsImageLoaded(false)}
						alt="" />}
					<div className="absolute bottom-[-55px] left-0 right-0 flex justify-center">
						<motion.div {...fadeInUp}
							className=" w-1/4  rounded-full overflow-hidden border-2 border-white"
						>
							{data.basicDetails &&
								<img src={newImgUrl + data.basicDetails.profileImg}
									className={`
									transition-all duration-500 ${isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"
										}
									`}
									onLoad={() => setIsImageLoaded(false)}
									alt="" />}
						</motion.div>
					</div>
				</div>

				<motion.div {...fadeInUp}>
					<div className="text-center">
						<div className="uppercase font-semibold text-2xl text-[#2d2d2d]">
							{data.basicDetails && data.basicDetails.name}

						</div>
						<div className="uppercase font-medium text-[#2d2d2d]">
							{data.basicDetails && data.basicDetails.currentDesignation}
						</div>
					</div>
				</motion.div>
				{/* <div className="flex justify-center items-center gap-10 my-5">
                    <div className="bg-slate-800 py-1 px-3 rounded-full uppercase text-white flex justify-center items-center gap-2">
                        <Phone width="25" fill="white" />
                        Phone
                    </div>
                    <div className="bg-slate-800 py-1 px-2 rounded-full uppercase text-white flex justify-center items-center gap-2">
                        <Phone width="25" fill="white" />
                        E-Mail
                    </div>
                </div> */}
				<div className="px-[20px] pt-[32px] pb-[4px]">
					<motion.div {...fadeInUp}>
						<div className="relative">
							<div className="absolute text-[#2d2d2d] top-[-14px] left-[15px] font-semibold text-[20px] bg-white px-[12px] z-50 common-font">
								About Me
							</div>
							<div className="border-[1.5px] border-[#2d2d2d] text-[#2d2d2d] p-[16px] text-justify rounded-xl text-[16px] font-medium common-font tracking-[0.1px]">
								{data.basicDetails && data.basicDetails.about}
							</div>
						</div>
					</motion.div>
					<motion.div {...fadeInUp}>
						<div className="relative my-7">
							<div className="absolute text-[#2d2d2d] top-[-14px] left-3 px-[12px] text-[20px] bg-white font-semibold common-font z-50">
								Certifications
							</div>
							<div className="border-[1.5px] border-[#2d2d2d] rounded-xl px-[16px] py-[12px]">
								{data.certification && data.certification.map((item, i) => (
									<span
										key={i}
										className="bg-[#2d2d2d] inline-block my-2 text-white py-1 px-[12px] rounded-full mx-1"
									>
										{item}
									</span>
								))}
							</div>
						</div>
					</motion.div>
					<motion.div {...fadeInUp}>
						<div className="relative">
							<div className="absolute text-[#2d2d2d] top-[-14px] left-3 px-[12px] text-[20px] bg-white font-semibold z-50">
								Education
							</div>
							<div className="border-[1.5px] border-[#2d2d2d] rounded-xl px-3 py-6">
								{data.education && data.education.map((edu, index) => (
									<div className="flex justify-between items-start relative">
										<div className="flex justify-center items-center gap-[0.75rem]">
											<div className="bg-[#2d2d2d] rounded-full p-[6px]">
												<Tick
													width="10"
													height="10"
													fill="white"
												/>
											</div>
											<div>
												<p className="font-semibold text-[17px] text-[#2d2d2d] m-0">
													{edu.major}
												</p>
												<span className=" text-[#2d2d2d]">
													{edu.college}
												</span>
											</div>
										</div>
										<div className="underline text-[#2d2d2d]">
											{edu.year}
										</div>
										{data.experience.length - 1 !== index && (
											<hr className="absolute left-[-11.5px] bottom-0 top-[59px] w-11 rotate-90 border-[2px] border-[#2d2d2d] rounded-full opacity-100 border-solid m-0" />
										)}
									</div>
								))}
							</div>
						</div>
					</motion.div>
					<motion.div {...fadeInUp}>
						<div className="relative my-7">
							<div className="absolute text-[#2d2d2d] text-[20px] top-[-14px] left-3 px-2 bg-white font-semibold z-10">
								Achievements
							</div>
							<ul className="border-[1.5px] border-[#2d2d2d] rounded-xl pt-2 px-3 m-0">
								{data.achievements && data.achievements.map((item, i) => (
									<li className="flex items-center gap-2 ms-1 my-3">
										<div className="bg-[#2d2d2d] p-[5px] rounded-full"></div>
										<div className="font-medium text-[17px] text-[#2d2d2d]">
											{item}
										</div>
									</li>
								))}
							</ul>
						</div>
					</motion.div>
					<motion.div {...fadeInUp}>
						<div className="relative">
							<div className="absolute text-[20px] text-[#2d2d2d] top-[-14px] left-3 px-2 bg-white font-semibold z-10">
								Work Experience
							</div>
							<div className="border-[1.5px] border-[#2d2d2d] rounded-xl p-4 py-4 px-3">
								{data.experience && data.experience.map((work, index) => (
									<div className="flex justify-between items-start relative">
										<div className="flex justify-center items-center gap-3">
											<div className="bg-[#2d2d2d] rounded-full p-[6px]">
												<Tick
													width="10"
													height="10"
													fill="white"
												/>
											</div>
											<div>
												<p className="font-semibold text-[17px] text-[#2d2d2d] m-0">
													{work.designation}
												</p>
												<span className="text-[#2d2d2d]">
													{work.company}
												</span>
											</div>
										</div>
										<div className="underline text-[#2d2d2d]">
											{work.year}
										</div>
										{data.experience.length - 1 !== index && (
											<hr className="absolute left-[-11.5px] bottom-0 top-[59px] w-11 rotate-90 border-[2px] border-[#2d2d2d] rounded-full opacity-100 border-solid m-0" />
										)}
									</div>
								))}
							</div>
						</div>
					</motion.div>
					<motion.div {...fadeInUp}>
						<div className="relative mt-7 mb-4">
							<div className="absolute text-[20px] text-[#2d2d2d] top-[-14px] left-3 px-2 bg-white font-semibold z-10">
								Skills
							</div>
							<div className="border-[1.5px] border-[#2d2d2d] rounded-xl px-[24px] py-[8px]">
								{
									data.skills && data.skills.map((skill, index) => (
										<div className="mt-3 mb-4">
											<div className="font-semibold text-[17px] text-[#2d2d2d] pb-[12px]">
												{skill.name}
											</div>
											<div class="w-full bg-gray-200 rounded-full h-1">
												<div style={{ width: `${skill.percentage}%` }} class={`bg-[#2d2d2d] h-1 w-[${skill.percentage}%] rounded-full`}></div>
											</div>
										</div>
									))
								}
							</div>
						</div>
					</motion.div>
				</div>
			</div>
		</div>
	);
};

export default Profile;
